import Home from './components/Home.vue'
import Questionnaire from './components/Questionnaire.vue'
import QuestionnaireComplete from './components/QuestionnaireComplete.vue'

const routes = [{
    path: '/',
    component: Home
}, {
    path: '/questionnaire',
    component: Questionnaire
}, {
    path: '/questionnaire-complete',
    component: QuestionnaireComplete
}];

export default routes;